export default __webpack_public_path__ + "static/char-55-9fb4b47ef359d9e8c51f511da450e5f3.webp";